// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c880b0b","728":"fc6b2674","845":"843e6197"}[chunkId] + ".chunk.js";
};